import Loadable from "@loadable/component";

const GuestRegistration = Loadable(
  () =>
    import(/* webpackChunkName: "guest_registration" */ "./guestRegistration")
);

export default GuestRegistration;
